import React from "react";
import ProjectRow from "./ProjectRow";

const CategoryRow = ({
    category,
    projects,
    customer,
    days,
    stats,
    updateHolidaySaldo,
    onWorkSessionSaved,
    isLoading
}) => {
    if (!category) return null;

    // SAFE: stats.categories kan undefined zijn
    const categoryStats =
        stats &&
        stats.categories &&
        stats.categories[category.id]
            ? stats.categories[category.id]
            : { total: 0, projects: {} };

    const categoryTotal = categoryStats.total || 0;

    // ✅ category name veilig bepalen
    const categoryName =
        category.name != null ? String(category.name) : "";

    const hasCategoryName = categoryName.trim() !== "";

    return (
        <div className="category-block">

            <div
                className="category-row-header indent-1"
                title={hasCategoryName ? categoryName : ""}
            >
                {hasCategoryName ? categoryName : ""}
                {(hasCategoryName && categoryTotal > 0)
                    ? ` (${categoryTotal})`
                    : ""}
            </div>

            {(projects || []).map(project => {
                const projectStats =
                    categoryStats.projects && categoryStats.projects[project.id]
                        ? categoryStats.projects[project.id]
                        : { total: 0 };

                return (
                    <ProjectRow
                        key={`cat-${category.id}-proj-${project.id}`}
                        project={project}
                        updateHolidaySaldo={updateHolidaySaldo}
                        days={days}
                        customer={customer}
                        stats={projectStats}
                        displayCategoryTitle={false}
                        onWorkSessionSaved={onWorkSessionSaved}
				        isLoading={isLoading}
                    />
                );
            })}
        </div>
    );
};

export default CategoryRow;
